<template>
  <main-layout>
    <p>Welcome home!</p>
    <div><a href="/Games/MineSweep">扫雷</a></div>
    <div><a href="/Games/ChineseChess">中国象棋</a></div>
  </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
export default {
  components: {
    MainLayout
  }
}
</script>